import React from 'react';
import { useFullscreenImageStore } from '../stores/fullscreenImageStore';
import { FullscreenImageOverlay } from '../design_system/FullscreenImageOverlay';
import { O } from '../lib/EffectExports';
export const FullscreenImageController = () => {
    const { imageUrl, clearFullscreenImage } = useFullscreenImageStore();
    return (React.createElement(FullscreenImageOverlay, { imageUrl: O.getOrUndefined(imageUrl), onClose: clearFullscreenImage, show: O.isSome(imageUrl) }));
};
//# sourceMappingURL=FullscreenImageController.js.map